import { render, staticRenderFns } from "./RegisterV3.vue?vue&type=template&id=fd452e0a&scoped=true&"
import script from "./RegisterV3.vue?vue&type=script&lang=js&"
export * from "./RegisterV3.vue?vue&type=script&lang=js&"
import style0 from "./RegisterV3.vue?vue&type=style&index=0&id=fd452e0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd452e0a",
  null
  
)

export default component.exports